module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"collapse":"Collapse","pinnedWorkspaces":"Pinned workspaces"},"ru":{"collapse":"Свернуть","pinnedWorkspaces":"Избранное"}}')
  delete Component.options._Ctor
}
